import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { getIcon } from "@/lib/icons";

export default function Facilities({ content }) {
  return (
    <section id="fasilitas" className="bg-fade-blue py-24" data-testid="facilities-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHeading
          number="05"
          eyebrow="Fasilitas"
          title="Fasilitas Perumahan Cluster"
          description="Informasi fasilitas kawasan akan terus diperbarui. Hubungi tim marketing untuk detail terkini."
        />
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {content.facilities.map((f, i) => {
            const Icon = getIcon(f.icon);
            return (
              <Reveal key={i} delay={(i % 3) * 0.08}>
                <div
                  className="h-full rounded-2xl border border-slate-100 bg-white p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgb(0,86,179,0.1)]"
                  data-testid={`facility-card-${i}`}
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-mist">
                    <Icon className="h-6 w-6 text-brand" />
                  </div>
                  <h3 className="mt-5 font-display text-lg font-bold text-brand-dark">{f.name}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{f.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
